import { render } from "./CancelTransaction.vue?vue&type=template&id=568936e2&scoped=true&ts=true"
import script from "./CancelTransaction.vue?vue&type=script&lang=ts"
export * from "./CancelTransaction.vue?vue&type=script&lang=ts"

import "./CancelTransaction.vue?vue&type=style&index=0&id=568936e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568936e2"],['__file',"src/components/transact/CancelTransaction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "568936e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('568936e2', __exports__)) {
    api.reload('568936e2', __exports__)
  }
  
  module.hot.accept("./CancelTransaction.vue?vue&type=template&id=568936e2&scoped=true&ts=true", () => {
    api.rerender('568936e2', render)
  })

}


export default __exports__